import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import HomePage from './components/hero/HomePage';
import Best from './components/best/Best';
import GridViewMain from './components/GridViewMain/GridViewMain';
import TestingModal from './components/TestingModal/TestingModal';
import Register from './components/login/Register/Register';
import Logout from './components/login/logout';
import Profil from './components/Profil/EditProfilForm';
import ProfilChoice from './components/Profil/ProfilChoice';
import ShippingPreferences from './components/Profil/ShippingPreferences';
import TradingPreferences from './components/Profil/TradingPreferences';
import DetailedCardView from './components/GridViewMain/CardFullView/DetailedCardView';
import MainCreateCardForm from './components/CreateCardForm/MainCreateCardForm';
import CollectionViewer from './components/CollectionViewer/CollectionViewer';
import WantListViewer from './components/CollectionViewer/WantListViewer';
import GridViewMainSell from './components/GridViewSellTrade/GridViewSell';
import GridViewMainTrade from './components/GridViewSellTrade/GridViewTrade';
import MainCardEdit from './components/GridViewMain/CardEdit/MainCardEdit';
import MainExport from './components/export/MainExport';
import FullUserprofilPage from './components/Profil/FullUserprofilPage';
import PrivacySettings from './components/Profil/PrivacySettings';
import PersonalCollection from './components/Charts/PersonalCollection';
import MessageDisplay from './components/Messages/MessageDisplayParent';
import FullMessage from './components/Messages/Updated version/FullMessage';
import AdminPanel from './components/AdminPanel/AdminPanel';
import ReviewSubmission from './components/AdminPanel/components/reviewSubmission';
import CustomInsertIntoCardName from './components/AdminPanel/components/customInsertIntoCardName';
import RazzBreakPanel from './components/RazzBreak/RazzBreakPanel';
import ProductsPage from './components/artisan/ProductsPage';
import CartPage from './components/Cart/CartPage';
import Chat from './components/Chat/Chat';
import CommunityChat from './components/CommunityChat/CommunityChat';
import UserPosts from './components/UserPosts/UserPosts';
import FAQ from './components/DefaultComponents/FAQ';
import AboutUs from './components/DefaultComponents/AboutUs';
import Mission from './components/footer/section/Mission';
import Security from './components/footer/section/Security';
import Blog from './components/footer/section/Blog';
import Terms from './components/footer/section/Terms';
import PrivacyPolicy from './components/footer/section/PrivacyPolicy';
import Shipping from './components/footer/section/Shipping';
import Payments from './components/footer/section/Payments';
import TradingRules from './components/footer/section/TradingRules';
import  ElementHomePage  from './iconosv0/src/screens/ElementHomePage/ElementHomePage';
//import ElementDetailOfACard from './ElementDetailOfACard/src/screens/ElementDetailOfACard/ElementDetailOfACard';
import ElementLogIn from './components/login/loginv2/ElementLogIn';
import ElementRegister from './components/login/loginv2/registerv2/ElementRegister';
import ElementDetailOfACard from './ElementDetailOfACard/ElementDetailOfACard';
import ElementCreateCards from './CreateCardListing/ElementCreateCards';
const MainRouter = () => {
  const { i18n } = useTranslation();
  const location = useLocation();

//  useEffect(() => {
//     const storedLang = localStorage.getItem('i18nextLng') || 'en';
// i18n.changeLanguage(storedLang);

//     // // Optional: sync with route prefix
//     // if (location.pathname.startsWith('/fr') && storedLang !== 'fr') {
//     //   i18n.changeLanguage('fr');
//     // } else if (!location.pathname.startsWith('/fr') && storedLang !== 'en') {
//     //   i18n.changeLanguage('en');
//     // }
//   }, [location.pathname, i18n]);


  useEffect(() => {
  const rawLang = localStorage.getItem('i18nextLng') || 'en';

  // Normalize language (handles en-CA, fr-CA, etc.)
  const normalizedLang = rawLang.startsWith('fr') ? 'fr' : 'en';

  if (i18n.language !== normalizedLang) {
    i18n.changeLanguage(normalizedLang);
  }
}, [location.pathname, i18n]);

  return (
    <Routes>
      {/* <Route path="/" element={<HomePage />} /> */}
       <Route path="/" element={<ElementHomePage />} />
      <Route path="/home" element={<ElementHomePage />} />
       <Route path="/login" element={<ElementLogIn />} />
      <Route path="/register" element={<ElementRegister />} />
        <Route path="/detail" element={<ElementDetailOfACard />} />
<Route path="/cards/:id" element={<ElementDetailOfACard />} />
        <Route path="/createcard" element={<ElementCreateCards />} />
      <Route path="/search" element={<Best />} />
      <Route path="/myCollection" element={<GridViewMain />} />
      <Route path="/modal" element={<TestingModal />} />
      <Route path="/register" element={<Register />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/profil" element={<Profil />} />
      <Route path="/profilchoice" element={<ProfilChoice />} />
      <Route path="/profil/shippingpreference" element={<ShippingPreferences />} />
      <Route path="/profil/tradingpreference" element={<TradingPreferences />} />
       {/* <Route path="/cards123/:id" element={<DetailedCardView />} />  */}
      <Route path="/createcardform" element={<MainCreateCardForm />} />
      <Route path="/public/collection/:listId" element={<CollectionViewer />} />
      <Route path="/public/wantlist/:listId" element={<WantListViewer />} />
      <Route path="/marketplace" element={<GridViewMainSell />} />
      <Route path="/marketplace/:view" element={<GridViewMainSell />} />
      <Route path="/gridviewmaintrade" element={<GridViewMainTrade />} />
      <Route path="/editcard/:id" element={<MainCardEdit />} />
      <Route path="/mainexport" element={<MainExport />} />
      <Route path="/viewuserprofil/:userName" element={<FullUserprofilPage />} />
      <Route path="/profil/privacysettings" element={<PrivacySettings />} />
      <Route path="/personalcollection" element={<PersonalCollection />} />
      <Route path="/messagedisplayparent" element={<MessageDisplay />} />
      <Route path="/messages/:targetUserId" element={<FullMessage />} />
      <Route path="/fullmessage" element={<FullMessage />} />
      <Route path="/adminpanel" element={<AdminPanel />} />
      <Route path="/review" element={<ReviewSubmission />} />
      <Route path="/custominsert" element={<CustomInsertIntoCardName />} />
      <Route path="/razzbreak" element={<RazzBreakPanel />} />
      <Route path="/product" element={<ProductsPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/communitychat" element={<CommunityChat />} />
      <Route path="/userposts" element={<UserPosts />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/aboutus" element={<AboutUs />} />
      <Route path="/mission" element={<Mission />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/security" element={<Security />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/shipping" element={<Shipping />} />
      <Route path="/payments" element={<Payments />} />
      <Route path="/trading-rules" element={<TradingRules />} />
    </Routes>
  );
};

export default MainRouter;